import React, { useEffect, useState } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import hallImg from "../../assets/images/resume.png";
import processImg from "../../assets/images/processing.png";
import { IsNullOrEmpty } from "../../helpers/utility";
import {
    cloneLiveStreamRequest,
    deleteBookMarkRequest,
    deleteLiveStreamRequest,
    fetchLiveStreamByIdRequest,
    updateLiveStreamRequest,
} from "../../store/social/social.actions";
import { getImage } from "../../store/user/user.selector";
import moment from "moment";
import $ from "jquery";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Menu,
    MenuItem,
    Modal,
    TextField,
} from "@material-ui/core";
import SharePop from "../../components/common/shareLivestream";

const LiveStreamCard = (props) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [shareModal, setShareModal] = useState(false);
    const [rename, setRename] = useState(false);
    const navigate = useNavigate();
    const { stream, canEdit } = props;
    const [title, setTitle] = useState(stream.title.indexOf("(copy)") > -1 ? stream.title : stream.title + " (copy)");

    const [hover, setHover] = useState(false);
    const [duration, setDuration] = useState(0);
    let infos = $("#" + stream.id + " video");
    const shareUrl =
        process.env.REACT_APP_URL + "/video/" + stream.id;

    useEffect(() => {
        if (duration === "00 : 00 : 00" && infos && infos[0]) {
            let ms = infos[0].duration * 1000;
            if (!isNaN(infos[0].duration)) {
                var d = moment.duration(ms);
                let duration1 = `${d._data.hours
                    .toString()
                    .padStart(2, "0")} : ${d._data.minutes
                        .toString()
                        .padStart(2, "0")} : ${d._data.seconds
                            .toString()
                            .padStart(2, "0")}`;
                setDuration(duration1);
            }
        }
    }, [infos]);

    useEffect(() => {
        setDuration(stream.duration);
    }, []);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    if (
        !IsNullOrEmpty(stream.streamUrl) &&
        stream.streamUrl.indexOf("png") === -1
    ) {
        let playlists = stream.streamUrl.split(",");
        if (playlists.length > 0) {
            if (playlists[0].indexOf("ularec.s3.us-west-1.amazonaws.com") > -1) {
                stream.clip = playlists[0].split("?")[0];
            }
            else {
                stream.clip = playlists[0];
            }
        }
    } else if (
        !IsNullOrEmpty(stream.s3Url)
    ) {
        let playlists = stream.s3Url.split(",");
        if (playlists.length > 0) {
            if (playlists[0].indexOf("ularec.s3.us-west-1.amazonaws.com") > -1) {
                stream.clip = playlists[0].split("?")[0];
            }
            else {
                stream.clip = playlists[0];
            }
        }
    } else {
        let haveImage = false;
        if (stream.attachments && stream.attachments.key) {
            haveImage = true;
        }
        let img = getImage(stream.attachments, true);
        if (!IsNullOrEmpty(stream.streamUrl)) {
            img = stream.streamUrl;
        }

        if (stream.streamingStatus.toLowerCase() === "waiting") {
            stream.image = hallImg;
        } else if (
            stream.streamingStatus.toLowerCase() === "ended" &&
            IsNullOrEmpty(stream.s3Url) && IsNullOrEmpty(stream.streamUrl)
        ) {
            stream.image = processImg;
        } else {
            stream.image = img;
        }
    }

    return (
        <div
            className="border border-black-10 rounded-lg w-full mx-auto sm:m-0"

        >
            <div className="mb-5 relative  rounded-tl-lg rounded-tr-lg" onClick={() => {
                if (canEdit) {
                    dispatch(
                        fetchLiveStreamByIdRequest({
                            id: stream.id,
                            history: null,
                        })
                    );
                    navigate("/page/livestream/update")
                }
                else {
                    dispatch(
                        fetchLiveStreamByIdRequest({
                            id: stream.id,
                            history: navigate,
                        })
                    );
                }
            }}>
                {!IsNullOrEmpty(stream.clip) ? (
                    <ReactPlayer
                        muted
                        id={stream.id}
                        playing={hover}
                        url={stream.clip}
                        width="100%"
                        className="w-full rounded-tl-lg rounded-tr-lg card-video"
                        height="300px"
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        config={{
                            file: {
                                attributes: {
                                    controlsList: "nofullscreen",
                                },
                            },
                        }}
                    />
                ) : (
                    <img
                        src={stream.image}
                        className="w-full rounded-tl-lg rounded-tr-lg h-[300px]"
                        alt=""
                    />
                )}

                <div className="absolute top-0 left-0 right-0 w-full bottom-0 flex flex-col justify-between bg-black bg-opacity-10 cursor-pointer">
                    <div className="px-2 pt-2.5 flex items-start justify-end text-white">
                        {props.isBookmarking ? (
                            <svg
                                onClick={(e) => {
                                    e.stopPropagation();
                                    Swal.fire({
                                        title: "Confirm delete?",
                                        text: "A deleted starred livestream cannot be restored later.",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "red",
                                        cancelButtonText: "Cancel",
                                        confirmButtonText: "Delete",
                                        customClass: {
                                            cancelButton: "order-1 right-gap",
                                            confirmButton: "order-2",
                                            denyButton: "order-3",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            dispatch(
                                                deleteBookMarkRequest({
                                                    listBookmarkId: [
                                                        stream.bookMarkId,
                                                    ],
                                                })
                                            );
                                        }
                                    });
                                }}
                                width="18"
                                height="20"
                                viewBox="0 0 18 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M16 5L15.1327 17.1425C15.0579 18.1891 14.187 19 13.1378 19H4.86224C3.81296 19 2.94208 18.1891 2.86732 17.1425L2 5M7 9V15M11 9V15M12 5V2C12 1.44772 11.5523 1 11 1H7C6.44772 1 6 1.44772 6 2V5M1 5H17"
                                    stroke="white"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        ) : props.canDelete ? (
                            <BsThreeDotsVertical
                                onClick={handleClick}
                                className="text-2xl cursor-pointer"
                            />
                        ) : (
                            <></>
                        )}
                        <Menu
                            id="simple-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={Boolean(anchorEl)}
                            onClose={handleClose}
                        >
                            {
                                canEdit && <MenuItem
                                    onClick={(event) => {
                                        event.preventDefault();
                                        event.stopPropagation();
                                        dispatch(
                                            fetchLiveStreamByIdRequest({
                                                id: stream.id,
                                                history: null,
                                            })
                                        );
                                        navigate("/page/livestream/update")
                                    }}
                                >
                                    Edit
                                </MenuItem>
                            }

                            <MenuItem
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    setRename(true);
                                }}
                            >
                                Rename
                            </MenuItem>
                            <MenuItem
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    Swal.fire({
                                        title: "Confirm duplicate",
                                        text: "Are you sure?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "green",
                                        cancelButtonText: "Cancel",
                                        confirmButtonText: "Duplicate",
                                        customClass: {
                                            cancelButton: "order-1 right-gap",
                                            confirmButton: "order-2",
                                            denyButton: "order-3",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            dispatch(
                                                cloneLiveStreamRequest(
                                                    stream.id
                                                )
                                            );
                                        }
                                    });
                                }}
                            >
                                Duplicate
                            </MenuItem>
                            <MenuItem
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    handleClose();
                                    setShareModal(true);
                                }}
                            >
                                Share
                            </MenuItem>
                            <MenuItem
                                onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    Swal.fire({
                                        title: "Confirm delete?",
                                        text: "A deleted livestream cannot be restored later.",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "green",
                                        cancelButtonText: "Cancel",
                                        confirmButtonText: "Delete",
                                        customClass: {
                                            cancelButton: "order-1 right-gap",
                                            confirmButton: "order-2",
                                            denyButton: "order-3",
                                        },
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            dispatch(
                                                deleteLiveStreamRequest(
                                                    stream.id
                                                )
                                            );
                                        }
                                    });
                                    handleClose();
                                }}
                            >
                                Delete
                            </MenuItem>
                        </Menu>
                    </div>
                    <div className="flex justify-between p-1.5">
                        <div className="cursor-pointer flex items-center">
                            <img
                                src={stream?.users?.owner?.image}
                                className="w-8 h-8 border border-white rounded-full"
                                alt=""
                            />
                            <h5
                                className={`text-sm font-medium capitalize ${!IsNullOrEmpty(stream.clip)
                                    ? "text-white"
                                    : "text-black"
                                    } ml-2`}
                            >
                                {stream?.users?.owner?.name}
                            </h5>
                        </div>
                        <button className="text-sm font-bold text-white py-0.5 px-2 rounded-[5px] bg-orange-color">
                            {stream.streamingStatus.toLowerCase() !== "streaming" ? duration : "Live"}
                        </button>
                    </div>
                </div>
            </div>
            <div className="px-4 pb-[18px]">
                <h4 className="text-base font-bold text-ebony-color mb-2.5">
                    {stream.title}
                </h4>
                <div className="flex mb-5 -space-x-4 h-[30px]">
                    {stream.users.guests.map((x) => {
                        return (
                            <img
                                className="w-10 h-10 rounded-full border-2 border-white dark:border-gray-800"
                                src={x.image}
                                alt=""
                            />
                        );
                    })}
                </div>

                <div className="flex items-center gap-x-3">
                    <div className="text-sm text-black-50 font-medium flex items-center hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                                className="mr-2.5 stroke-current"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M9.99984 5.99998C9.99984 7.10455 9.10441 7.99998 7.99984 7.99998C6.89527 7.99998 5.99984 7.10455 5.99984 5.99998C5.99984 4.89541 6.89527 3.99998 7.99984 3.99998C9.10441 3.99998 9.99984 4.89541 9.99984 5.99998Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M1.63867 5.99996C2.48819 3.29523 5.01504 1.33331 8.00013 1.33331C10.9852 1.33331 13.5121 3.29526 14.3616 6C13.5121 8.70473 10.9852 10.6666 8.00014 10.6666C5.01504 10.6666 2.48817 8.70471 1.63867 5.99996Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{stream.watch}</p>
                    </div>
                    <div className="text-sm text-black-50 font-medium flex items-center hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="14"
                                height="15"
                                viewBox="0 0 14 15"
                                fill="none"
                                stroke="currentColor"
                                className="mr-2.5"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.3333 4.33335H11.6667C12.403 4.33335 13 4.93031 13 5.66669V9.66669C13 10.4031 12.403 11 11.6667 11H10.3333V13.6667L7.66667 11H5C4.63181 11 4.29848 10.8508 4.05719 10.6095M4.05719 10.6095L6.33333 8.33335H9C9.73638 8.33335 10.3333 7.7364 10.3333 7.00002V3.00002C10.3333 2.26364 9.73638 1.66669 9 1.66669H2.33333C1.59695 1.66669 1 2.26364 1 3.00002V7.00002C1 7.7364 1.59695 8.33335 2.33333 8.33335H3.66667V11L4.05719 10.6095Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{stream.comment}</p>
                    </div>
                    <div className="text-sm text-black-50 font-medium flex items-center hover:text-orange-color cursor-pointer">
                        <span>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                className="mr-2.5 stroke-current"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7 3V7H10M13 7C13 7.78793 12.8448 8.56815 12.5433 9.2961C12.2417 10.0241 11.7998 10.6855 11.2426 11.2426C10.6855 11.7998 10.0241 12.2417 9.2961 12.5433C8.56815 12.8448 7.78793 13 7 13C6.21207 13 5.43185 12.8448 4.7039 12.5433C3.97595 12.2417 3.31451 11.7998 2.75736 11.2426C2.20021 10.6855 1.75825 10.0241 1.45672 9.2961C1.15519 8.56815 1 7.78793 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        <p>{stream.date}</p>
                    </div>
                </div>
            </div>
            <Dialog
                fullWidth
                maxWidth="sm"
                open={shareModal}
                onClose={(e) => {
                    e.stopPropagation();
                    setShareModal(false);
                }}
            >
                <DialogContent>
                    <SharePop
                        onClose={() => setShareModal(false)}
                        shareUrl={shareUrl}
                        title={stream?.users?.owner?.name}
                        subTitle={"@" + stream?.users?.owner?.userName}
                        image={stream?.users?.owner?.image}
                        heading="Share"
                    />
                </DialogContent>
            </Dialog>
            <Dialog
                maxWidth="sm"
                fullWidth
                open={rename}
                onClose={(e) => {
                    e.stopPropagation();
                    setRename(false);
                }}
            >
                <DialogTitle>
                    Rename video
                </DialogTitle>
                <DialogContent>
                    <TextField
                        value={title}
                        margin="dense"
                        onChange={(e) => {
                            setTitle(e.target.value);
                            e.stopPropagation();
                        }}
                        fullWidth
                        variant="outlined"
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="contained" color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            dispatch(updateLiveStreamRequest({
                                id: stream.id,
                                name: title
                            }))
                        }}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </div >
    );
};

export default LiveStreamCard;
